// Action Types
import {
        GET_BANK_SUCCESS, GET_BANKS_SUCCESS, ADD_BANK_SUCCESS
        } from '../actions/actionTypes';

// Utils
import { getNewState } from '../shared/utils/frontend';

// Initial State
const initialState = {};

export default function bankReducer(state = initialState, action) {
  switch (action.type) {
    
    /*
    case GET_BANK_SUCCESS:
    {
      const {payload: bank} = action;
      console.log('ACTION');
      console.log(action);
      return getNewState(state, {
        bank
      });
    }
    break;
    */
    
    case GET_BANKS_SUCCESS:
    {
      const {payload: result} = action;
      console.log('ACTION');
      console.log(action);
      return getNewState(state, {
        result
      });
    }
    break;
    
    /*
    case ADD_BANK_SUCCESS:
    {
      const {payload: banks} = action;
      return getNewState(state, {
        banks
      });
    }
    break;
    */
 
  default:
      return state;
}
};